"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/alert/style/css");

var _alert = _interopRequireDefault(require("antd/es/alert"));

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

require("antd/es/date-picker/style/css");

var _datePicker = _interopRequireDefault(require("antd/es/date-picker"));

require("antd/es/input/style/css");

var _input = _interopRequireDefault(require("antd/es/input"));

require("antd/es/descriptions/style/css");

var _descriptions = _interopRequireDefault(require("antd/es/descriptions"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _testkit = require("../../redux/testkit/testkit.types");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  Item
} = _descriptions.default;
const inputStyle = {
  marginTop: '5px',
  marginBottom: '5px'
};

class TestkitRequestedCard extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = {
      trackingNumber: '',
      estimatedDeliveryDate: '',
      fulfillmentError: false
    };

    this.handleFulfillment = e => {
      e.stopPropagation();
      const {
        fulfillTestkit,
        testkit
      } = this.props;
      const {
        id
      } = testkit;
      const {
        trackingNumber,
        estimatedDeliveryDate
      } = this.state;

      if (trackingNumber.length > 0 && estimatedDeliveryDate.length > 0) {
        const testkitArg = {
          id,
          trackingNumber,
          estimatedDeliveryDate
        };
        fulfillTestkit(testkitArg);
        this.setState({
          fulfillmentError: false
        });
      } else {
        this.setState({
          fulfillmentError: true
        });
      }
    };
  }

  componentDidMount() {}

  onChange(state) {
    this.setState(state);
  }

  render() {
    const {
      testkit
    } = this.props;
    const {
      participant
    } = testkit;
    const {
      trackingNumber
    } = this.state;

    if (!participant) {
      return /*#__PURE__*/_react.default.createElement("div", null, "Participant Not Found.");
    }

    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_descriptions.default, {
      layout: "vertical",
      column: 5,
      size: "small",
      colon: false
    }, /*#__PURE__*/_react.default.createElement(Item, {
      label: "Fulfillment:",
      span: 1
    }, /*#__PURE__*/_react.default.createElement("span", null, `${testkit.firstName} ${testkit.lastName}`), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("span", null, `${testkit.address1}`), /*#__PURE__*/_react.default.createElement("br", null), testkit.address2 ? /*#__PURE__*/_react.default.createElement("span", null, `${testkit.address2}`, /*#__PURE__*/_react.default.createElement("br", null)) : '', /*#__PURE__*/_react.default.createElement("span", null, `${testkit.city}, ${testkit.state} ${testkit.postalCode}`), /*#__PURE__*/_react.default.createElement("br", null)), /*#__PURE__*/_react.default.createElement(Item, {
      label: "Type"
    }, /*#__PURE__*/_react.default.createElement("span", {
      style: {
        fontSize: '18px',
        fontWeight: 'bold'
      }
    }, `${testkit.type}`)), /*#__PURE__*/_react.default.createElement(Item, {
      label: "Tracking ID:"
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      placeholder: "Tracking ID",
      style: inputStyle,
      onChange: event => this.onChange({
        trackingNumber: event.target.value
      })
    })), /*#__PURE__*/_react.default.createElement(Item, {
      label: "Estimated Delivery Date:"
    }, /*#__PURE__*/_react.default.createElement(_datePicker.default, {
      style: inputStyle,
      onChange: (date, dateString) => this.onChange({
        estimatedDeliveryDate: dateString
      })
    })), /*#__PURE__*/_react.default.createElement(Item, null, /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "primary",
      onClick: this.handleFulfillment,
      style: inputStyle
    }, "Submit"))), /*#__PURE__*/_react.default.createElement(_alert.default, {
      style: this.state.fulfillmentError ? {
        visibility: 'visible'
      } : {
        visibility: 'hidden'
      },
      message: "Must provide Tracking ID and Estimated Delivery Date.",
      type: "error",
      showIcon: true
    }));
  }

}

const mapDispatchToProps = dispatch => {
  return {
    fulfillTestkit: testkit => dispatch(_testkit.fulfillTestkitAsync.request(testkit))
  };
};

var _default = (0, _reactRedux.connect)(null, mapDispatchToProps)(TestkitRequestedCard);

exports.default = _default;